// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SiHaDocumentationStatusListResultModel from '../../model/si-ha-documentation-status-list-result-model';
import SiHaDocumentationStatusListResultDTO from '../dto/si-ha-documentation-status-list-result-dto';
import dtoSchema from '../schemas/si-ha-documentation-status-list-result-schema';
import SiHaDocumentationStatusModel from '../../model/si-ha-documentation-status-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class SiHaDocumentationStatusListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SiHaDocumentationStatusListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SiHaDocumentationStatusModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: SiHaDocumentationStatusModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<SiHaDocumentationStatusListResultDTO>): SiHaDocumentationStatusListResultModel;
  static toModel(dto: DeepPartial<SiHaDocumentationStatusListResultDTO> | undefined | null): SiHaDocumentationStatusListResultModel | undefined;
  static toModel(dto: DeepPartial<SiHaDocumentationStatusListResultDTO> | undefined | null): SiHaDocumentationStatusListResultModel | undefined {
    return dto ? new SiHaDocumentationStatusListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SiHaDocumentationStatusListResultModel> | SiHaDocumentationStatusListResultModel): SiHaDocumentationStatusListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as SiHaDocumentationStatusListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SiHaDocumentationStatusListResultModel, can not map to SiHaDocumentationStatusListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
